import React from 'react';
import CreateReferral from './CreateReferral';
import CreatePromotion from './CreatePromotion';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const CreateDiscount = (props) => {
  const { state } = useLocation();
  // Make the check case-insensitive
  const offerType = (state?.offerType || state?.tab || '').toUpperCase();

  if (offerType === 'PROMOTION') {
    return <CreatePromotion {...props} />;
  }
  // Default to referral
  return <CreateReferral {...props} />;
};

export default CreateDiscount;
